module.exports = __webpack_public_path__ + "img/vcf-mobile.d4680543.png";